var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.972,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2734 1.7589C36.7826 1.62178 37.9675 2.16865 38.8281 3.39952C39.2255 4.16192 39.3557 4.96921 39.2188 5.8214C38.955 7.86608 38.4472 9.8453 37.6953 11.7589C35.0941 8.74101 32.3077 5.90247 29.3359 3.24327C31.2689 2.52895 33.2481 2.03416 35.2734 1.7589Z",
    fill: "#6A097D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.985,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.852 3.71163C27.9847 3.69912 28.1149 3.71214 28.2426 3.75069C31.4118 6.55529 34.3675 9.56312 37.1098 12.7741C37.2025 12.8948 37.2285 13.025 37.1879 13.1648C35.1481 17.7231 32.1924 21.5903 28.3207 24.7663C25.9702 26.5794 23.3399 27.8294 20.4301 28.5163C19.3826 28.6451 18.4451 28.3847 17.6176 27.7351C15.8017 26.2839 14.2002 24.6302 12.8129 22.7741C12.5428 22.3155 12.4256 21.8206 12.4613 21.2898C12.5939 19.4726 13.1277 17.7799 14.0629 16.2116C17.1777 10.4041 21.7741 6.23748 27.852 3.71163ZM25.8988 10.6648C28.0047 10.5387 29.5021 11.4241 30.391 13.321C31.0672 15.5208 30.4552 17.2526 28.5551 18.5163C26.3306 19.5129 24.4687 19.0572 22.9691 17.1491C21.8364 15.0534 22.1359 13.1913 23.8676 11.5632C24.4877 11.1184 25.1648 10.8189 25.8988 10.6648Z",
    fill: "#6A097D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5078 11.6797C15.612 11.7318 15.612 11.7318 15.5078 11.6797V11.6797Z",
    fill: "#6A097D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.97,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5078 11.7578C14.3889 13.3688 13.3863 15.0616 12.5 16.8359C11.8996 18.1034 11.4959 19.4315 11.2891 20.8203C9.37305 19.6509 7.2897 18.9868 5.03906 18.8281C3.92061 18.7491 2.80082 18.697 1.67969 18.6719C5.42123 14.6657 10.0306 12.361 15.5078 11.7578Z",
    fill: "#6A097D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.969,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2884 11.7578C28.6834 11.978 29.7381 13.2802 29.4525 15.6641C28.7064 17.567 27.3393 18.2571 25.3509 17.7344C23.6928 16.9019 23.1069 15.5868 23.5931 13.7891C24.1068 12.5895 25.0052 11.9124 26.2884 11.7578Z",
    fill: "#6A097D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.938,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8358 23.3984C13.354 25.3723 15.0988 27.1302 17.0702 28.6719C17.1744 28.724 17.1744 28.776 17.0702 28.8281C16.1061 28.9799 15.1426 28.9799 14.1796 28.8281C12.7797 28.3909 11.9594 27.4404 11.7186 25.9766C11.5816 25.1077 11.6207 24.2484 11.8358 23.3984Z",
    fill: "#6A097D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.967,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8828 24.8047C29.7167 27.2172 28.9745 29.4568 27.6562 31.5234C26.0378 33.8459 24.1628 35.9553 22.0312 37.8516C21.9233 36.0763 21.767 34.3054 21.5625 32.5391C21.4251 31.5468 21.1777 30.5832 20.8203 29.6484C23.5502 28.8823 26.0762 27.6974 28.3984 26.0938C28.9314 25.7038 29.4262 25.2741 29.8828 24.8047Z",
    fill: "#6A097D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.918,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.18 26.7578C9.86164 26.793 10.0309 27.1055 9.68781 27.6953C7.2599 29.7852 4.72083 31.7253 2.07062 33.5156C1.75886 33.6911 1.43333 33.8343 1.09406 33.9453C0.717021 33.8162 0.586813 33.5559 0.703436 33.1641C1.02562 32.7871 1.37718 32.4355 1.75812 32.1094C4.13883 30.1826 6.61279 28.3987 9.18 26.7578Z",
    fill: "#6A097D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.912,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5859 29.1032C11.197 29.0771 11.4184 29.3636 11.25 29.9626C10.7578 30.9758 10.0416 31.7961 9.10156 32.4235C8.67891 32.4855 8.44453 32.3031 8.39844 31.8766C8.83711 30.7272 9.56633 29.8027 10.5859 29.1032Z",
    fill: "#6A097D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.917,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0859 30.2742C13.5002 30.1942 13.7606 30.3505 13.8672 30.743C13.6152 31.6419 13.2636 32.5013 12.8125 33.3211C12.025 34.8188 11.1396 36.2511 10.1562 37.618C9.98395 37.8164 9.78864 37.9857 9.57028 38.1258C9.03247 38.213 8.81106 37.9916 8.90622 37.4617C9.99153 35.3691 11.1373 33.3118 12.3437 31.2898C12.5779 30.9389 12.8254 30.6004 13.0859 30.2742Z",
    fill: "#6A097D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketIcon);
export default __webpack_public_path__ + "static/media/RocketIcon.954665acc64543825ddd3d9e0cada1f2.svg";
export { ForwardRef as ReactComponent };